import { ChainId } from '@uniswap/sdk-core'
import AppRpcProvider from 'rpc/AppRpcProvider'
import AppStaticJsonRpcProvider from 'rpc/StaticJsonRpcProvider'
import StaticJsonRpcProvider from 'rpc/StaticJsonRpcProvider'

import { SupportedInterfaceChain } from './chains'
import { RPC_URLS } from './networks'

const providerFactory = (chainId: SupportedInterfaceChain, i = 0) =>
  new AppStaticJsonRpcProvider(chainId, RPC_URLS[chainId][i])

/**
 * These are the only JsonRpcProviders used directly by the interface.
 */
export const RPC_PROVIDERS: { [key in SupportedInterfaceChain]: StaticJsonRpcProvider } = {
  [ChainId.MAINNET]: new AppRpcProvider(ChainId.MAINNET, [
    providerFactory(ChainId.MAINNET),
    providerFactory(ChainId.MAINNET, 1),
  ]),
  [ChainId.GOERLI]: providerFactory(ChainId.GOERLI),
  [ChainId.SEPOLIA]: providerFactory(ChainId.SEPOLIA),
  [ChainId.OPTIMISM]: providerFactory(ChainId.OPTIMISM),
  [ChainId.OPTIMISM_GOERLI]: providerFactory(ChainId.OPTIMISM_GOERLI),
  [ChainId.ARBITRUM_ONE]: providerFactory(ChainId.ARBITRUM_ONE),
  [ChainId.ARBITRUM_GOERLI]: providerFactory(ChainId.ARBITRUM_GOERLI),
  [ChainId.POLYGON]: providerFactory(ChainId.POLYGON),
  [ChainId.POLYGON_MUMBAI]: providerFactory(ChainId.POLYGON_MUMBAI),
  [ChainId.CELO]: providerFactory(ChainId.CELO),
  [ChainId.CELO_ALFAJORES]: providerFactory(ChainId.CELO_ALFAJORES),
  [ChainId.BNB]: providerFactory(ChainId.BNB),
  [ChainId.AVALANCHE]: providerFactory(ChainId.AVALANCHE),
  [ChainId.BASE]: providerFactory(ChainId.BASE),
  [ChainId.DBK]: providerFactory(ChainId.DBK),
  [ChainId.BERACHAIN]: providerFactory(ChainId.BERACHAIN),
  [ChainId.HYPERLIQUID]: providerFactory(ChainId.HYPERLIQUID),
  [ChainId.SONIC]: providerFactory(ChainId.SONIC),
  [ChainId.KATANA]: providerFactory(ChainId.KATANA),
  [ChainId.MITOSIS]: providerFactory(ChainId.MITOSIS),
  [ChainId.SOMNIA]: providerFactory(ChainId.SOMNIA),
  [ChainId.ZEROG]: providerFactory(ChainId.ZEROG),
  [ChainId.PLASMA]: providerFactory(ChainId.PLASMA),
  [ChainId.MONAD_TESTNET]: providerFactory(ChainId.MONAD_TESTNET),
  [ChainId.MONAD]: providerFactory(ChainId.MONAD),
  [ChainId.MEGAETH]: providerFactory(ChainId.MEGAETH),
  [ChainId.STABLE]: providerFactory(ChainId.STABLE),
}
